import ExpandableText from '@/components/ExpandableText';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsContent = () => {
  const { diary } = useDiaryShortsContext();

  return (
    <div className="max-h-[50vh] overflow-y-scroll">
      <ExpandableText
        lines={2}
        text={diary.content}
        className="english-truncate text-16px font-normal leading-6 text-gray-300"
        anchorClassName="text-gray-300 font-semibold text-15px leading-6"
      />
    </div>
  );
};

export default _DiaryShortsContent;
